/* Copyright (C) mroads, LLC - All Rights Reserved
 * Unauthorized copying of this file, via any medium is strictly prohibited
 * Proprietary and confidential
 * Written by Premsagar Choudhary <premsagar.choudhary@mroads.com>, June 2021
 * @format
 * @flow
 */

import moment from 'moment';
import { ActionTypes } from '../constants';

const defaults = {
  printLogs: [],
};

export interface ActionType {
  type: string;
  payload: any;
}

export default (state = defaults, action: ActionType) => {
  switch (action.type) {
    case ActionTypes.ADD_PRINT_LOG: {
      const { printLogs } = state;
      const { log } = action.payload;
      const newLines = [...printLogs];
      if (printLogs.length >= 1000) {
        newLines.splice(0, 1);
      }
      const formattedLog = `${newLines.length+1}. ${moment(new Date()).format('YYYY-MM-DD hh:mm:ss')} - ${log}`;
      newLines.unshift(formattedLog)
      return {
        ...state,
        printLogs: [...newLines],
      };
    }
    case ActionTypes.CLEAR_PRINT_LOG: {
      return {
        ...state,
        printLogs: [],
      };
    }
    default: {
      return { ...state };
    }
  }
};
